import type { UiCommandBusV2, UiSnapshotV2 } from "@/ui/runtime/contracts/manager-ui-v2";
import { Button } from "@/ui/foundation/primitives/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui/foundation/primitives/card";

interface ResultOverlayProps {
    snapshot: UiSnapshotV2;
    commands: UiCommandBusV2;
}

export function ResultOverlay({ snapshot, commands }: ResultOverlayProps) {
    if (snapshot.activeOverlayRoute !== "/manager/result" || !snapshot.routes.result.visible) {
        return null;
    }

    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4">
            <Card className="w-full max-w-2xl">
                <CardHeader>
                    <CardDescription>Full Time</CardDescription>
                    <CardTitle>{snapshot.routes.result.fixture}</CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col gap-4">
                    <div className="text-2xl font-semibold">{snapshot.routes.result.score}</div>
                    <div className="space-y-1 text-sm text-muted-foreground">
                        {snapshot.routes.result.scorers.map((scorer) => (
                            <div key={scorer}>{scorer}</div>
                        ))}
                    </div>
                    {snapshot.routes.result.otherResults.length > 0 ? (
                        <div>
                            <div className="mb-2 text-sm font-medium">Other Results</div>
                            <div className="space-y-1 text-sm text-muted-foreground">
                                {snapshot.routes.result.otherResults.map((result) => (
                                    <div key={result}>{result}</div>
                                ))}
                            </div>
                        </div>
                    ) : null}
                    <div className="flex justify-end gap-2">
                        <Button variant="outline" onClick={() => void commands.backToHub()}>Back To Hub</Button>
                        <Button onClick={() => void commands.resultContinue()}>Continue</Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
